import React from "react";
import { ArrowRight } from "lucide-react";
import { Reveal } from "../motion/Reveal";

const INDUSTRIES = [
  { name: "Corporate Offices", note: "Boardroom to floor-plate IT for enterprise HQs and coworking campuses." },
  { name: "Manufacturing", note: "Ruggedised networking, SCADA-friendly infra, and 24×7 uptime SLAs." },
  { name: "Healthcare", note: "HIS-ready networks, DICOM-grade storage and clinical-area surveillance." },
  { name: "BFSI", note: "Compliance-first hardware, DR-ready sites, and audit-grade CCTV." },
  { name: "Government", note: "GeM listings, tender documentation, PAN-India rollout logistics." },
  { name: "Educational Institutions", note: "Classroom AV, campus Wi-Fi and lab endpoints, at institutional scale." },
  { name: "System Integrators", note: "Wholesale corporate pricing, stock availability, white-glove partner support." },
];

export default function Industries() {
  return (
    <section id="industries" className="relative bg-[#222222] py-24 lg:py-36 overflow-hidden" data-testid="industries-section">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 mb-16 lg:mb-24">
          <Reveal className="lg:col-span-6">
            <div className="section-label mb-6">Industries We Serve · A Manifesto</div>
            <h2 className="font-display text-[#FAFAFA] text-[40px] sm:text-[56px] lg:text-[80px] leading-[0.95] tracking-[-0.03em]">
              Seven verticals.<br />
              <span className="text-[#A4161A]">One</span> operating standard.
            </h2>
          </Reveal>
          <Reveal delay={0.15} className="lg:col-span-5 lg:col-start-8 flex items-end">
            <p className="text-[#FAFAFA]/70 max-w-[46ch] leading-relaxed font-body text-[15px] lg:text-[16px]">
              Every industry inherits our full playbook — engineering, compliance, logistics and
              support. What changes is the domain vocabulary, not the standard of delivery.
            </p>
          </Reveal>
        </div>

        <div className="border-b border-[#9A9A9A]/18">
          {INDUSTRIES.map((it, i) => (
            <Reveal key={it.name} delay={i * 0.05}>
              <div className="industry-row py-8 lg:py-10 grid grid-cols-12 items-center gap-6" data-testid={`industry-${i}`}>
                <div className="col-span-2 sm:col-span-1 chapter-num !text-[44px] sm:!text-[56px] lg:!text-[72px] !leading-none">
                  {String(i + 1).padStart(2, "0")}
                </div>
                <div className="col-span-10 sm:col-span-5">
                  <h3 className="font-display text-[#FAFAFA] text-[22px] sm:text-[28px] lg:text-[36px] leading-tight tracking-tight">
                    {it.name}
                  </h3>
                </div>
                <div className="col-span-12 sm:col-span-5 text-[#9A9A9A] font-body text-[13px] lg:text-[14px] leading-relaxed">
                  {it.note}
                </div>
                <div className="hidden sm:flex col-span-1 justify-end">
                  <ArrowRight className="industry-arrow" size={22} />
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
